import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import isNumber from 'lodash/isNumber';
import { BILL_STATUS, BILL_TILE_TYPE, ORDER_STATUS } from 'src/modules/Order/constants';

import OrderSummaryTile from 'src/components/OrderSummaryTile';

import theme from 'src/styles/components/Order.module.scss';

import OrderTile from './OrderTile';

const Order = React.memo(({
    orderNumber,
    item
}) => {
    const intl = useIntl();

    let lastPosition = {};
    let scrollType;

    const handleTouchStart = (event) => {
        const touchobj = event.changedTouches[0];

        lastPosition = {
            x: touchobj.pageX,
            y: touchobj.pageY
        };

        scrollType = undefined;
    };

    const handleTouchMove = (event) => {
        const touchobj = event.changedTouches[0];

        if (typeof (lastPosition.x) !== 'undefined') {
            const deltaX = lastPosition.x - touchobj.pageX;
            const deltaY = lastPosition.y - touchobj.pageY;

            if (Math.abs(deltaX) > Math.abs(deltaY) && deltaX > 0 && !scrollType) {
                scrollType = 'X';
            } else if (Math.abs(deltaX) > Math.abs(deltaY) && deltaX < 0 && !scrollType) {
                scrollType = 'X';
            } else if (Math.abs(deltaY) > Math.abs(deltaX) && deltaY > 0 && !scrollType) {
                scrollType = 'Y';
            } else if (Math.abs(deltaY) > Math.abs(deltaX) && deltaY < 0 && !scrollType) {
                scrollType = 'Y';
            }

            if (scrollType === 'Y') {
                if (event.cancelable) {
                    event.preventDefault();
                }

                event.stopPropagation();
            }
        }
    };

    const handleTouchEnd = (event) => {
        if (scrollType === 'Y') {
            if (event.cancelable) {
                event.preventDefault();
            }

            event.stopPropagation();
        }
    };

    const { status, billStatus } = item;

    return (
        <div className={theme.contentContainer}>
            <div
              className={classnames(theme.content, {
                [theme.statusPlaced]: status === ORDER_STATUS.PLACED,
                [theme.statusCompleted]: status === ORDER_STATUS.COMPLETED || billStatus === BILL_STATUS.ABORTED,
                [theme.statusAccepted]: status === ORDER_STATUS.ACCEPTED,
                [theme.typeOrder]: !item.type || item.type === BILL_TILE_TYPE.ORDER
              })}
              role="presentation"
              onTouchMove={handleTouchMove}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
              body-scroll-lock-ignore=""
            >
                {(!item.type || item.type === BILL_TILE_TYPE.ORDER) && (
                    <OrderTile {...item} billStatus={billStatus} status={status} orderNumber={orderNumber} />
                )}
                {item.type === BILL_TILE_TYPE.SUMMARY && (
                    <OrderSummaryTile {...item} />
                )}
            </div>
            {isNumber(item.summary) && (
                <div className={theme.orderSummary}>
                    <span>
                        {intl.formatMessage({ id: 'App.orderSum' })}
                    </span>
                    <span>
                        {intl.formatNumber(item.summary, { style: 'currency', currency: 'PLN' })}
                    </span>
                </div>
            )}
        </div>
    );
});

Order.propTypes = {
    orderNumber: PropTypes.number,
    item: PropTypes.shape({
        status: PropTypes.number,
        billStatus: PropTypes.number,
        summary: PropTypes.number,
        type: PropTypes.number
    })
};

export default Order;
